<template>
  <div style="height: 100%">
    <fdc-panel
      :title="'컬럼 별 Sorting & Filtering'"
      style="height: 100%;"
    >
      <brique-grid
        style="width: 100%; height: 70%;"
        id="dataSortFilter"
        :brique-grid-columns="columnDefs"
        @grid-ready="onGridReady"
        :default-col-def="defaultColDef"
        :row-selection="rowSelection"
        :row-data="rowData"
      />
      <hr>
      <monaco-editor
        ref="MonacoEditor"
        :code="comment"
        :automatic-layout="true"
        :read-only="true"
        :theme="'vs-dark'"
        style="height: 25%"
      />
    </fdc-panel>
  </div>
</template>

<script>
import MonacoEditor from '@/views/Fdc/EqpInfo/Components/MonacoEditor.vue'

export default {
  name: 'DataSortFilter',
  components: {
    'monaco-editor': MonacoEditor
  },
  methods: {
    async onGridReady (params) {
      this.gridApi = params.api
      this.gridColumnApi = params.columnApi

      await this.refreshData()
    },
    async refreshData () {
      const updateData = (data) => {
        this.rowData = data
        this.gridApi.setRowData(data)
      }

      await fetch('https://www.ag-grid.com/example-assets/olympic-winners.json')
        .then((resp) => resp.json())
        .then((data) => updateData(data.slice(0, 100).map(d => {
          d.date = d.date.split('/').reverse().join('/') // date format이 DD/MM/YYYY 여서 converting함
          return d
        })))
    }
  },
  data: function () {
    return {
      gridApi: null,
      columnApi: null,
      columnDefs: [
        { field: 'athlete', minWidth: 150, checkboxSelection: true },
        { field: 'age', maxWidth: 90, type: 'numericColumn' },
        { field: 'country', minWidth: 150 },
        { field: 'year', maxWidth: 90 },
        { field: 'date', minWidth: 150, type: 'dateColumn' },
        { field: 'sport', minWidth: 150 },
        { field: 'gold', type: 'numericColumn' },
        { field: 'silver', type: 'numericColumn' },
        { field: 'bronze', type: 'numericColumn' },
        { field: 'total', type: 'numericColumn' }
      ],
      defaultColDef: {
        // flex: 1,
        minWidth: 100,
        filter: true,
        resizable: true,
        sortable: true
      },
      rowSelection: 'multiple',
      rowData: null,
      comment: [
        '/*',
        ' * 주요 설정 (상세 사용법은 소스 참조)',
        ' * - BRIQUE Grid default column 설정 변경',
        ' * - BRIQUE Grid column 정의에 column data type 지정',
        ' */',
        '// default column 설정',
        'defaultColDef: {',
        '\tfilter: true, // filter 기능 활성화',
        '\tsortable: true // sort 기능 활성화',
        '\t...',
        '},',
        '// column data type 지정 (default는 string)',
        'columnDefs: [',
        '\t{ field: \'age\', maxWidth: 90, type: \'numericColumn\' }, // number column 일 때',
        '\t{ field: \'date\', minWidth: 150, type: \'dateColumn\' } // date column 일 때',
        '\t...',
        ']'
      ].join('\n')
    }
  }
}
</script>

<style lang="scss">
  .fdc-panel {
    .panel-body {
      padding: 10px;
    }
  }
</style>
